import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
import { AppVersionBlockProps } from './index';

const style = () =>
  createStyles({
    root: {
      fontSize: '0.625rem',
      fontWeight: 500,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: (props: AppVersionBlockProps) =>
        props.variant === 'light' ? palette.text.white : palette.text.secondary,
      userSelect: 'none'
    },
    logo: {
      marginBottom: '10px',
      '& > path': {
        fill: (props: AppVersionBlockProps) =>
          props.variant === 'light'
            ? palette.text.white
            : palette.text.secondary
      }
    },
    text: {
      marginTop: '0',
      marginBottom: '5px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
